// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---src-pages-404-jsx": function componentSrcPages404Jsx() {
    return import("./../../src/pages/404.jsx"
    /* webpackChunkName: "component---src-pages-404-jsx" */
    );
  },
  "component---src-pages-candidates-jsx": function componentSrcPagesCandidatesJsx() {
    return import("./../../src/pages/candidates.jsx"
    /* webpackChunkName: "component---src-pages-candidates-jsx" */
    );
  },
  "component---src-pages-home-old-jsx": function componentSrcPagesHomeOldJsx() {
    return import("./../../src/pages/home-old.jsx"
    /* webpackChunkName: "component---src-pages-home-old-jsx" */
    );
  },
  "component---src-templates-blog-jsx": function componentSrcTemplatesBlogJsx() {
    return import("./../../src/templates/blog.jsx"
    /* webpackChunkName: "component---src-templates-blog-jsx" */
    );
  },
  "component---src-templates-donate-jsx": function componentSrcTemplatesDonateJsx() {
    return import("./../../src/templates/donate.jsx"
    /* webpackChunkName: "component---src-templates-donate-jsx" */
    );
  },
  "component---src-templates-page-jsx": function componentSrcTemplatesPageJsx() {
    return import("./../../src/templates/page.jsx"
    /* webpackChunkName: "component---src-templates-page-jsx" */
    );
  },
  "component---src-templates-post-jsx": function componentSrcTemplatesPostJsx() {
    return import("./../../src/templates/post.jsx"
    /* webpackChunkName: "component---src-templates-post-jsx" */
    );
  },
  "component---src-templates-who-represents-me-jsx": function componentSrcTemplatesWhoRepresentsMeJsx() {
    return import("./../../src/templates/who-represents-me.jsx"
    /* webpackChunkName: "component---src-templates-who-represents-me-jsx" */
    );
  }
};